import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_GOOGLE_AUTH_USE_IDENTITY_SERVICES = createFcmConfig('google_auth_use_identity_services', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
